import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URL_GLOBAL } from 'src/environments/environment';
import { AuthService } from '../vos/auth.service';

@Injectable({
  providedIn: 'root',
})
export class OrcsService {
  constructor(private http: HttpClient, private authService: AuthService) {}
  get(): Observable<any[]> {
    return this.http.get<any[]>(`${URL_GLOBAL}/orcs`);
  }
  save(data: any): Observable<any> {
    return this.http.post<any>(`${URL_GLOBAL}/orcs`, data);
  }
  find(param: any, id: any): Observable<any> {
    return this.http.get(`${`${URL_GLOBAL}/orcs`}/${id}`, {
      params: new HttpParams().append('commands', JSON.stringify(param)),
    });
  }

  update(id: any, data: any): Observable<any> {
    return this.http.put<any>(`${URL_GLOBAL}/orcs/${id}`, data);
  }

  alterarSituacao(id: any, data: any): Observable<any> {
    return this.http.put<any>(`${URL_GLOBAL}/alterarsituacao/${id}`, data);
  }

  destroy(id: any): Observable<any> {
    return this.http.delete<any>(`${`${URL_GLOBAL}/orcs`}/${id}`);
  }
  PegarTodosOsRegistrosPorIdDaEmpresa(param: any): Observable<any[]> {
    return this.http.get<any[]>(`${URL_GLOBAL}/orcs`, {
      params: new HttpParams().append('commands', JSON.stringify(param)),
    });
  }
  filtroPorPeriodoEClienteOrcs(param): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/orcs/filtroPorPeriodoECliente?data=${
        param.data ? param.data : ''
      }&cliente_id=${param.cliente_id ? param.cliente_id : ''}`,
      { headers: this.authService.userToken() }
    );
  }
  // Novo Rota com Autenticação
  getOrcamentos(url, nome): Observable<Array<any>> {
    return this.http.get<any[]>(
      `${url ? url : `${URL_GLOBAL}/web/orcs?page=1`}&filter_nome=${
        nome ? nome : ''
      }`,
      { headers: this.authService.userToken() }
    );
  }
  pegarOrcamentoPorId(id): Observable<any> {
    return this.http.get<any>(`${URL_GLOBAL}/web/orcs/${id}`, {
      headers: this.authService.userToken(),
    });
  }
  salvarNovoOrcamento(orcamento): Observable<any> {
    return this.http.post<any>(`${URL_GLOBAL}/web/orcs`, orcamento, {
      headers: this.authService.userToken(),
    });
  }
  atualizarOrcamento(id, orcamento): Observable<any> {
    return this.http.put<any>(`${URL_GLOBAL}/web/orcs/${id}`, orcamento, {
      headers: this.authService.userToken(),
    });
  }
  desativarOrcamento(id): Observable<any> {
    return this.http.delete<any>(`${URL_GLOBAL}/web/orcs/${id}`, {
      headers: this.authService.userToken(),
    });
  }
  buscaQuantidadeOrcamentosPorSituacao(param, token: any): Observable<any[]> {
    const headers = new HttpHeaders({
      Authorization: token['token_type'] + ' ' + token.access_token,
    });
    // return this.http.get<any[]>(`${URL_GLOBAL}/web/orcs/quantidadeOrcPorSituacao`, { headers });
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/orcs/quantidadeOrcPorSituacao?data_ini=${param.dataInicio}&data_fim=${param.dataFim}`,
      { headers }
    );
  }
  // quantidadeOrcamentosPorCliente(orcamento, token): Observable<any> {
  //   return this.http.get<any>(`${URL_GLOBAL}/web/orcs/orcamentoporcliente`, orcamento, { headers: this.authService.userToken() });
  // }
  buscaQuantidadeOrcamentosPorTipo(param): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/orcs/quantidadeOrcsPorTipo?data_ini=${param.dataInicio}&data_fim=${param.dataFim}`,
      { headers: this.authService.userToken() }
    );
  }
  buscaQuantidadeOrcamentosPorCliente(param, nome): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/orcs/quantidadeOrcsPorCliente?data_ini=${
        param.dataInicio
      }&data_fim=${param.dataFim}&filter_nome=${nome ? nome : ''}`,
      { headers: this.authService.userToken() }
    );
  }
  buscaQuantidadeOrcsPorServico(param, nome): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/orcs/quantidadeOrcsPorServico?data_ini=${
        param.dataInicio
      }&data_fim=${param.dataFim}&filter_nome=${nome ? nome : ''}`,
      { headers: this.authService.userToken() }
    );
  }

  enviarOrcamentoPorEmail(file?, emails?): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('emails', JSON.stringify(emails));
    if (file) {
      formData.append('file', file, file.name);
    } else {
      formData.append('file', '');
    }
    return this.http.post<any>(
      `${URL_GLOBAL}/web/gestaoOrcamentaria/orcamentos/enviarOrcamentoPorEmail`,
      formData,
      { headers: this.authService.userToken() }
    );
  }
  gerarCodigo(token): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: token['token_type'] + ' ' + token.access_token,
    });
    return this.http.get<any>(`${URL_GLOBAL}/web/orcs/gerarCodigo`, {
      headers,
    });
  }

  // Orcs Servicos
  apagarOrcservico(id): Observable<any> {
    return this.http.delete<any>(
      `${URL_GLOBAL}/web/orcs/apagarOrcservico/${id}`,
      { headers: this.authService.userToken() }
    );
  }
  // Orcs Produto
  apagarOrcproduto(id): Observable<any> {
    return this.http.delete<any>(
      `${URL_GLOBAL}/web/orcs/apagarOrcproduto/${id}`,
      { headers: this.authService.userToken() }
    );
  }

  //BUDGETS
  getBudgets(param: any): Observable<Array<any>> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/budgets?filter_name=${param.name ? param.name : ''}${
        param.client_id ? `&cliente_id=${param.client_id}` : ''
      }${param.situation ? `&situation=${param.situation}` : ''}${
        param.status ? `&status=${param.status}` : ''
      }`,
      { headers: this.authService.userToken() }
    );
    // return this.http.get<any[]>(`${url ? url : `${URL_GLOBAL}/web/budgets?page=1`}&filter_nome=${nome ? nome : ''}`, { headers: this.authService.userToken() });
  }
  salvarBudget(orcamento): Observable<any> {
    return this.http.post<any>(`${URL_GLOBAL}/web/budget`, orcamento, {
      headers: this.authService.userToken(),
    });
  }

  updateBudgetProductValues(budget_id) {
    return this.http.patch(
      `${URL_GLOBAL}/web/update-budget-products/${budget_id}`,
      {},
      { headers: this.authService.userToken() }
    );
  }

  destroyBudget(id): Observable<any> {
    return this.http.delete<any>(`${URL_GLOBAL}/web/destroy-budget/${id}`, {
      headers: this.authService.userToken(),
    });
  }

  activeBudget(id, token: any, data: any): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: token['token_type'] + ' ' + token.access_token,
    });
    return this.http.put<any>(`${URL_GLOBAL}/web/active-budget/${id}`, data, {
      headers,
    });
  }

  acceptedBudget(id, orcamento): Observable<any> {
    return this.http.put<any>(
      `${URL_GLOBAL}/web/accepted-budget/${id}`,
      orcamento,
      { headers: this.authService.userToken() }
    );
  }

  updateGuideNumber(id, guide_number): Observable<any> {
    return this.http.patch<any>(
      `${URL_GLOBAL}/web/update-guide-number/${id}`,
      { guide_number },
      { headers: this.authService.userToken() }
    );
  }

  notAcceptedBudget(id, orcamento): Observable<any> {
    return this.http.put<any>(
      `${URL_GLOBAL}/web/not-accepted-budget/${id}`,
      orcamento,
      { headers: this.authService.userToken() }
    );
  }

  atualizarBudget(id, orcamento): Observable<any> {
    return this.http.put<any>(`${URL_GLOBAL}/web/budget/${id}`, orcamento, {
      headers: this.authService.userToken(),
    });
  }
  alterarSituacaoBudget(id, orcamento): Observable<any> {
    return this.http.put<any>(
      `${URL_GLOBAL}/web/budget/situation/${id}`,
      orcamento,
      { headers: this.authService.userToken() }
    );
  }
  findBudget(id): Observable<any> {
    return this.http.get<any>(`${URL_GLOBAL}/web/budget/${id}`, {
      headers: this.authService.userToken(),
    });
  }
  db(): Observable<any> {
    return this.http.get<any>(`${URL_GLOBAL}/buscaOrcamentos`);
  }

  atualizaEscalas(item): Observable<any> {
    return this.http.post<any>(`${URL_GLOBAL}/atualizaEscalas`, item);
  }
  dbOrcsToTranscricao(): Observable<any> {
    return this.http.get<any>(`${URL_GLOBAL}/buscaOrcsToTranscricao`);
  }

  atualizaTranscricao(item): Observable<any> {
    return this.http.post<any>(`${URL_GLOBAL}/atualizaTranscricao`, item);
  }
  getBudgetsByModalContracts(param: any): Observable<Array<any>> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/budgets/list-budgets-by-contracts?filter_name=${
        param.name ? param.name : ''
      }`,
      { headers: this.authService.userToken() }
    );
  }

  deletePackageByBudget(id): Observable<any> {
    return this.http.post<any>(`${URL_GLOBAL}/web/budgets/delete-package`, id);
  }

  // EXCLUIR ITENS SEPARADOS EM ORÇAMENTOS
  excluirItemBudgetServico(id): Observable<any> {
    return this.http.delete<any>(
      `${URL_GLOBAL}/web/budgets/excluir/servico/${id}`,
      { headers: this.authService.userToken() }
    );
  }
  excluirItemBudgetProduto(id): Observable<any> {
    return this.http.delete<any>(
      `${URL_GLOBAL}/web/budgets/excluir/produto/${id}`,
      { headers: this.authService.userToken() }
    );
  }
}
